import React, { useState } from "react";
import FsLightbox from "fslightbox-react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import gallery1 from "../../../assets/farm/img_1.jpg";
import gallery2 from "../../../assets/farm/img_2.JPG";
import gallery3 from "../../../assets/farm/img_3.JPG";
import gallery4 from "../../../assets/farm/img_4.jpg";
import gallery5 from "../../../assets/farm/img_5.jpg";
import gallery6 from "../../../assets/farm/img_6.jpg";
import gallery7 from "../../../assets/farm/img_7.jpg";
import gallery8 from "../../../assets/farm/img_8.jpg";
import gallery9 from "../../../assets/farm/img_9.jpg";
import gallery10 from "../../../assets/farm/img_10.jpg";
import gallery11 from "../../../assets/farm/img_11.jpg";
import gallery12 from "../../../assets/farm/img_12.jpg";
import gallery13 from "../../../assets/farm/img_13.jpg";
import gallery14 from "../../../assets/farm/img_14.jpg";
import gallery15 from "../../../assets/farm/img_15.jpg";
import gallery16 from "../../../assets/farm/img_16.jpg";
import gallery17 from "../../../assets/farm/img_17.jpg";
import gallery18 from "../../../assets/farm/img_18.jpg";
import gallery19 from "../../../assets/farm/img_19.jpg";
import gallery20 from "../../../assets/farm/img_20.jpg";
import gallery21 from "../../../assets/farm/img_21.jpg";
import gallery22 from "../../../assets/farm/img_22.jpg";
import gallery23 from "../../../assets/farm/img_23.jpg";
import gallery24 from "../../../assets/farm/img_24.jpg";

const Gallery = () => {
  const theme = useTheme();

  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });

  const photos = [
    gallery1,
    gallery2,
    gallery3,
    gallery4,
    gallery5,
    gallery6,
    gallery7,
    gallery8,
    gallery9,
    gallery10,
    gallery11,
    gallery12,
    gallery13,
    gallery14,
    gallery15,
    gallery16,
    gallery17,
    gallery18,
    gallery19,
    gallery20,
    gallery21,
    gallery22,
    gallery23,
    gallery24,
  ];

  const photosToShow = isMd ? photos : photos.slice(0, photos.length);

  return (
    <Box padding={{ xs: "30% 0%", sm: "10% 0%" }}>
      <Box
        width={{ xs: "100%", sm: "40%" }}
        marginLeft={{ xs: "0%", sm: "0%" }}
      >
        <Typography
          variant={"h3"}
          fontWeight={900}
          textAlign={"left"}
          color={"#00AEEF"}
          paddingBottom={"1%"}
        >
          <Typography
            component={"span"}
            variant={"h3"}
            color="#3E4095"
            fontWeight={900}
          >
            Our {""}
          </Typography>
          Gallery
          <Divider color={"#CACACA"} paddingTop={"4%"} width={"15%"} />
        </Typography>
      </Box>
      <Box marginTop={{ xs: "5%", sm: "2%" }}>
        {photosToShow.map((item, index) => (
          <Box
            component="img"
            height={{ xs: "27vh", sm: "200px" }}
            onClick={() => {
              setCurrentImageIndex(index);
              setIsViewerOpen(!isViewerOpen);
            }}
            sx={{
              cursor: "pointer",
              objectFit: "cover",
            }}
            src={item}
            alt={"training_img"}
            marginRight={{ xs: "0%", sm: "0.7%" }}
            marginBottom={{ xs: "1%", sm: "0.5%" }}
            width={{ xs: "100%", sm: "24%" }}
          />
        ))}

        <FsLightbox
          toggler={isViewerOpen}
          sources={photos}
          slide={currentImageIndex + 1}
        />
      </Box>
    </Box>
  );
};

export default Gallery;
